export default {
    "Login": "Login",
    "logout": "Logout",
    "Email": "Email",
    "Enter your email": "Enter your email",
    "Password": "Password",
    "Enter your password": "Enter your password",
    "forgotPassword": "Forgot Password?",
    "create_new_account": "Create an account",
    "save_changes": "Save Changes",
    "back": "Back",
    "cancel": "Cancel",
    "reset": "Reset",
    "copy": "Copy",
    "yes": "Yes",
    "no": "No",
    "ok": "OK",
    "copied": "Copied!",
    "copy_failed": "Copy Failed :(",
    "reset_failed": "Reset Failed :(",
    "reset_succeeded": "Success!",
    "delete_failed": "Delete Failed :(",
    "delete_success": "Success!",

    "MenuTitleGeneral": "General",
    "MenuTitleGames": "Games",
    "MenuTitleApps": "Apps",
    "MenuNoGamesPlaceholder": "Currently No Games set...",
    "MenuNoAppsPlaceholder": "Currently No Apps set...",
    "MenuGeneralAccount": "Account",
    "MenuGeneralSubscription": "Subscription",
    "MenuGeneralInbox": "Inbox",
    "MenuGeneralStatistics": "Statistics",
    "MenuGamesOverview_Tooltip": "Games Overview",
    "MenuGamesAddNew_Tooltip": "Add New Game",
    "MenuAppsOverview_Tooltip": "Games Overview",
    "MenuAppsAddNew_Tooltip": "Add New Game",

    "General.msg.error.not_all_required_fields_are_set": "You have not filled in all required fields. Please fill in all required fields.",
    "General.msg.error.failed_parsing_json": "Failed to parse JSON: {1}",
    "Login.msg.error.something_went_wrong": "Something went wrong logging in. Please try again later. (Code: {1})",

    "GamesOverview.main_title": "Created Games",
    "GamesOverview.main_body": "This section shows all your created games. Click on a game to open the settings for that specific game.",

    "GameInfo.label_description": "Description",
    "GameInfo.label_game_info": "Game Information",
    "GameInfo.label_game_info_participation_type": "Participation Type",
    "GameInfo.label_game_info_participation_method": "Participation Method",
    "GameInfo.label_add_game": "Add Game",
    "GameInfo.msg.addgame_failed_title":"Game Creation Failed!",
    "GameInfo.msg.addgame_failed_body":"Unfortunately the game could not be created. Please try again later. Issue: {1}",
    "GameInfo.msg.addgame_success_title":"Game Created!",
    "GameInfo.msg.addgame_success_body":"The game is created and can be set up. Use the menu on the left to navigate between games.",

    "GameSettings.label_overlay_details_title": "Overlay",
    "GameSettings.label_overlay_details_body": "To show the game on your stream you need to add the overlay to it. Use the link below in a browser source and position it on your scene.",
    "GameSettings.label_game_name": "Game Name",
    "GameSettings.label_game_name_explanation": "The identifier for this games instance.",
    "GameSettings.label_title": "Game Title",
    "GameSettings.label_game_key": "Game Key",
    "GameSettings.label_game_key_field": "Game Key",
    "GameSettings.label_game_key_explanation": "The game key is the unique identifier for this specific game and is required for when you want to control the game from other external locations.",
    "GameSettings.msg.show_game_key_title": "Reveal Game Key?",
    "GameSettings.msg.show_game_key_body": "Your game key is a private access code that links directly to your setup. Never share this key with anyone as it could allow others to control your configuration. If you are live streaming, ensure this key is not visible on screen. Are you sure you want to reveal it?",
    "GameSettings.msg.reset_confirmation_title": "Are you sure you want to reset the Game Key?",
    "GameSettings.msg.reset_confirmation_body": "Your game key is a private access code that links directly to your setup. If you reset it, it means that all currently linked applications or calls no longer work and should be updated with the new key.",    
    "GameSettings.label_game_details": "Game Information",
    "GameSettings.label_game_details_description": "Check out the instructional video for this game type below.",
    "GameSettings.label_game_setup": "Setup your Game",
    "GameSettings.label_game_setup_explanation": "Use this settings to set up your game to your liking.",
    "GameSettings.label_game_state": "Game State",
    "GameSettings.label_game_state_description": "The live state of the game. If not live, it cannot be used in streams.",
    "GameSettings.label_game_theme": "Theme",
    "GameSettings.label_game_theme_explanation": "Choose the theme for the game overlay you use on your stream.",
    "GameSettings.label_game_controllers": "How to control the game",
    "GameSettings.label_game_controllers_explanation": "This section shows how to control your game using the different methods provided. We provide different methods to control the game with. This allows you to use our games also in situations where we do not have a direct integration. Some methods also have additional advantages. For more information, visit our website.",
    "GameSettings.label_game_remove_game": "Delete Game",
    "GameSettings.label_game_remove_game_description": "Delete the game from your dashboard. This action cannot be undone.",
    "GameSettings.label_game_remove_btn": "Delete Game",
    "GameSettings.msg.deletegame_confirmation_title": "Delete Game?",
    "GameSettings.msg.deletegame_confirmation_body": "Are you sure you want to delete the game? You will loose all settings and this action can't be undone.",
    "GameSettings.msg.deletegame_failed_title": "Delete Game Failed",
    "GameSettings.msg.deletegame_failed_body": "Unfortunately, something went wrong when deleting the game (Code: {1}). Please try again and submit a bug ticket when it keeps failing.",

    "GameSettings.label_connection_deckblox_app":"Deckblox Games Controller App",
    "GameSettings.label_connection_deckblox_app_description":"Control this game using the Deckblox Game Controller App. Install the controller app on your desktop. Read the manual on how to use the app to control your game and let your viewers interact with it. To be able to control this game using the deckblox app you need to enable it.",
    "GameSettings.label_connection_direct_twitch":"Direct Twitch Connection",
    "GameSettings.label_connection_direct_twitch_description":"Control your game by directly integrating it with your Twitch account and start listening for interaction from your viewers to your game. ",
    "GameSettings.label_connection_http":"Control using HTTP calls",
    "GameSettings.label_connection_http_description":"You can control your game also by using HTTP calls. This can be useful for when you want to control the game and the input from somewhere we do not have an integration for. This feature however does require you to execute all calls manually to be able to play this game with your viewers. Read the manual on how to set it up.",
    "GameSettings.label_connection_touch_portal":"Touch Portal",
    "GameSettings.label_connection_touch_portal_description":"You can control this game using our plugin for Touch Portal.",
    "GameSettings.label_connection_streamdeck":"Stream Deck",
    "GameSettings.label_connection_streamdeck_description":"You can control this game using our Stream Deck plugin.",

    "MenuUntitledGamePlaceholder": "Untitled Game",

    "Ending placeholder": "value"

    
};
